import { trimTimeFromDate } from '@/util/common'
const srConfigsByLevelLoading = (state) => state.srConfigsByLevelLoading
const srConfigsByLevel = (state) => (state.srConfigsByLevel || []).sort((a, b) => b.from - a.from)
const srConfigsByLevelError = state => state.srConfigsByLevelError

const successRatesLoading = state => state.successRatesLoading

const currentMonth = state => state.currentMonth

const noMoreSuccessRate = state => state.noMoreSuccessRate

const successRates = (state, getters, rootState, rootGetters) => {
  let perodList = rootGetters['app/periodList']

  if (state.successRates && state.successRates.length > 0) {
    state.successRates.map((obj) => {
      perodList.map((o) => {
        if (trimTimeFromDate(o.from, ' ') === trimTimeFromDate(obj.from_date, 'T')) {
          obj['formatted'] = o.formatted
          return obj
        }
      })
    })

    return state.successRates
  } else {
    return null
  }
}
const lastLoadedSuccessRateMonth = state => {
  let successRates = (state.successRates || [])
  let lastItem = successRates[successRates.length - 1]
  if (lastItem && lastItem.from_date) {
    return lastItem.from_date
  }

  return ''
}

const successRateMap = state => {
  let map = {}
  let successRates = state.successRates || []
  successRates.forEach(item => {
    if (item.hasOwnProperty('success_rate')) {
      let d1 = trimTimeFromDate(item.from_date, 'T')
      let d2 = trimTimeFromDate(item.to_date, 'T')
      let formtToOrderDate = `${d1}.${d2}`
      map[formtToOrderDate] = item.success_rate.toFixed(1)
    }
  })

  return map
}

export default {
  srConfigsByLevel,
  srConfigsByLevelLoading,
  srConfigsByLevelError,
  successRates,
  successRatesLoading,
  noMoreSuccessRate,
  successRateMap,
  lastLoadedSuccessRateMonth,
  currentMonth
}
